<div id="mySidenav1" class="sidenav">
    <div class="maintextContainer">
        <h1>Filter</h1>
        <i class="fa fa-times closebtn " aria-hidden="true" (click)="close()"></i>
    </div>
    <div class="headingContainer">
        <button class="button" [style.border-bottom]="duration" (click)="border('duration')"
            id="general">Duration</button>
        <button class="button" [style.border-bottom]="general" (click)="border('general')"
            id="advanced">Location</button>
        <button class="button" [style.border-bottom]="advanced" (click)="border('advanced')"
            id="advanced">Advanced</button>
        <button class="button" [style.border-bottom]="columns" (click)="border('columns')" id="columns">Hide
            Columns</button>
    </div>

    <form class="firstcontainer" [formGroup]="main" [style.display]="filterContainerdisplay">
        <div class="row">
            <div class="col-sm-12">
                <mat-label class="fontsize">State</mat-label>
                <mat-select class="form-control" placeholder="Select State" formControlName="StateControl">
                  <!-- Autocomplete for State -->
                  <input matInput [matAutocomplete]="stateAuto" formControlName="StateControl2" class="intbtn" placeholder="Select State">
                  <mat-autocomplete autoActiveFirstOption #stateAuto="matAutocomplete"></mat-autocomplete>
                    <mat-option *ngFor="let item of stateOptions | async" [value]="item?.stateName" (click)="handleStateSelection(item)">
                      {{ item.stateName }}
                    </mat-option>
           
                </mat-select>
              </div>
            <div class="col-sm-12" >
                <mat-label class="fontsize"> City</mat-label>
                <mat-select class="form-control" placeholder="Select City" formControlName="CityControl">
                    <input matInput [matAutocomplete]="classauto" formControlName="CityControl2" class="intbtn"
                        placeholder="select Class">
                    <mat-autocomplete autoActiveFirstOption #classauto="matAutocomplete"></mat-autocomplete>
                    <mat-option *ngFor="let class of cityOptions | async" (click)="getCampus(class)"
                        (click)="clearCampus()" [value]="class?.cityName">
                        {{class.cityName}}</mat-option>
                </mat-select>
            </div>
            <div class="col-sm-12">
                <mat-label class="fontsize"> Campus</mat-label>
                <mat-select class="form-control" placeholder="Select Campus" formControlName="CampusControl">
                    <input matInput [matAutocomplete]="groupauto" formControlName="CampusControl2" class="intbtn"
                        placeholder="select Group">
                    <mat-autocomplete autoActiveFirstOption #groupauto="matAutocomplete"></mat-autocomplete>
                    <mat-option *ngFor="let group of campusOptions | async" [value]="group?.campusName"
                        (click)="getCampusID(group)" (click)="clearBuilding()">{{group.campusName}}</mat-option>
                </mat-select>
            </div>
            
        </div>
    </form>
    <form class="firstcontainer" [formGroup]="addFilter" [style.display]="addFilterDisplay">
        <div class="row">
           <div class="col-sm-12" >
                <mat-label class="fontsize"> Building</mat-label>
                <div>
                    <mat-select #buuilding (click)="getdymaic();buuilding.open()"  (openedChange)="openedChange($event)"class="form-control" placeholder="Select Building" formControlName="BuildingControl">
                        <input matInput [matAutocomplete]="groupauto" formControlName="BuildingControl2" class="intbtn"
                            placeholder="select Group" #buildingSelect>
                        <mat-autocomplete autoActiveFirstOption #groupauto="matAutocomplete"></mat-autocomplete>
                        <mat-option *ngIf="loading" disabled><mat-spinner diameter="20"></mat-spinner> Loading options...
                        </mat-option>
                        <mat-option *ngFor="let group of buildingOptions | async" [value]="group" (click)="getClass(group)"
                            (click)="clearClass()" >{{group.Name}}</mat-option>
                    </mat-select>
                </div>
            </div>
            <div class="col-sm-12" >
                <mat-label class="fontsize">Class</mat-label>
                <mat-select #class class="form-control" (click)="dymaicclasslist();class.open()"  (openedChange)="openedChange($event)" placeholder="select Class" formControlName="ClassControl">
                    <input matInput [matAutocomplete]="cityauto" formControlName="ClassControl2" class="intbtn"
                        placeholder="select Class">
                    <mat-autocomplete autoActiveFirstOption #cityauto="matAutocomplete"></mat-autocomplete>
                    <mat-option *ngIf="loading" disabled><mat-spinner diameter="20"></mat-spinner> Loading options...
                    </mat-option>
                    <mat-option *ngFor="let item of classOptions | async" [value]="item" (click)="getStream(item)"
                        (click)="clearStream()">{{item.Name}}</mat-option>
                </mat-select>
            </div>
            <div class="col-sm-12" >
                <mat-label class="fontsize">Stream</mat-label>
                <mat-select #stream class="selectOptions" (click)="dymaicstream();stream.open()"  (openedChange)="openedChange($event)" placeholder="select Stream" formControlName="StreamControl">
                    <input matInput [matAutocomplete]="cityauto" formControlName="StreamControl2" class="intbtn"
                        placeholder="select Stream">
                    <mat-autocomplete autoActiveFirstOption #cityauto="matAutocomplete"></mat-autocomplete>
                    <mat-option *ngIf="loading" disabled><mat-spinner diameter="20"></mat-spinner> Loading options...
                    </mat-option>
                    <mat-option *ngFor="let item of streamOptions | async" [value]="item" (click)="getProgram(item)"
                        (click)="clearProgram()">{{item.Name}}</mat-option>
                </mat-select>
            </div>
          
            <div class="col-sd-12" >
                <mat-label class="fontsize">Program</mat-label>
                <mat-select #program class="form-control"(click)="dymaicprogram();program.open()"  (openedChange)="openedChange($event)"placeholder="select Program" formControlName="ProgramControl">
                    <input matInput [matAutocomplete]="cityauto" formControlName="ProgramControl2" class="intbtn"
                        placeholder="select Program">
                    <mat-autocomplete autoActiveFirstOption #cityauto="matAutocomplete"></mat-autocomplete>
                    <mat-option *ngIf="loading" disabled><mat-spinner diameter="20"></mat-spinner> Loading options...
                    </mat-option>
                    <mat-option *ngFor="let item of programOptions | async" [value]="item"
                        (click)="getSection(item)" (click)="clearSection()">{{item.Name}}</mat-option>
                </mat-select>
            </div>
            <div class="col-sm-12">
                <mat-label class="fontsize">Section</mat-label>
                <mat-select #section class="selectOptions"(click)=dymaicsesction();section.open()  (openedChange)="openedChange($event)" placeholder="select Section" formControlName="SectionControl" >
                    <input matInput [matAutocomplete]="cityauto" formControlName="SectionControl2" class="intbtn"
                        placeholder="select Section">
                    <mat-autocomplete autoActiveFirstOption #cityauto="matAutocomplete"></mat-autocomplete>
                    <mat-option *ngIf="loading" disabled><mat-spinner diameter="20"></mat-spinner> Loading options...
                    </mat-option>
                    <mat-option *ngFor="let item of sectionOptions | async" [value]="item" (click)="getExamProgram(item)"
                        (click)="clearExamProgram()">{{item.Name}}</mat-option>
                </mat-select>
            </div>
        </div>
    </form>
    <div class="container row table1" [style.display]="columnContainerdiaplay">
        <table>
            <tr>
                <td>
                    <div class="form-check form-check-inline w-50 height" *ngFor="let item of firstHalf">
                        <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" checked>
                        <label class="form-check-label" for="inlineCheckbox1">{{item.name}}</label>
                    </div>
                </td>
                <td>
                    <div class="form-check form-check-inline w-50 height" *ngFor="let item of secondHalf">
                        <input class="form-check-input" type="checkbox" id="inlineCheckbox2" value="option2" checked>
                        <label class="form-check-label" for="inlineCheckbox2">{{item.name}}</label>
                    </div>
                </td>
            </tr>

        </table>


    </div>
    <div class="applyContainer" [style.display]="applyContainerDisplay">
        <!-- <button class="applybtn clear" (click)="clearAll()">ClearAll</button> -->
        <button class="applybtn clear" (click)="searchfilter()">Search</button>
        <button class="applybtn " (click)="clearAll()">ClearAll</button>
    </div>
    <div class="card-body today-model" [style.display]="durationContainerDisplay">
        <div class="det-details">
            <div class="ibox-title report_flexweb">
                <!-- <div>
          <h5>Select Date</h5>
        </div> -->
                <!-- <div>
          <figure>
            <img src="../../assets/image/Group 28269.svg" />
          </figure>
        </div> -->
                <!-- </div> -->
                <!-- <mat-divider></mat-divider> -->
                <!-- <hr class="line"> -->
                <div class="box2">
                    <div class="example-card">
                        <h5 class="text1"> Search By duration </h5>
                    </div>
                    <div class="radio">
                        <div class="form-check form-check-inline with ">
                            <input class="form-check-input" type="radio" name="Radio2" id="inlineRadioOptions1"
                                (change)="onBehaviurSelect($event)" value="Today" [(ngModel)]="selectedValue">
                            <label class="form-check-label" for="inlineRadio1">Today</label>
                        </div>
                        <div class="form-check form-check-inline with">
                            <input class="form-check-input" type="radio" name="Radio2" id="inlineRadioOptions1"
                                (change)="onBehaviurSelect($event)" value="Yesterday" [(ngModel)]="selectedValue">
                            <label class="form-check-label" for="inlineRadio2">Yesterday</label>
                        </div>
                        <div class="form-check form-check-inline with">
                            <input class="form-check-input" type="radio" name="Radio2" id="inlineRadioOptions1"
                                (change)="onBehaviurSelect($event)" value="lastweek" [(ngModel)]="selectedValue">
                            <label class="form-check-label" for="inlineRadio3">Last Week</label>
                        </div>


                        <div class="form-check form-check-inline with">
                            <input class="form-check-input" type="radio" name="Radio2" id="inlineRadioOptions1"
                                (change)="onBehaviurSelect($event)" value="lastmonth" [(ngModel)]="selectedValue">
                            <label class="form-check-label" for="inlineRadio1">Last Month</label>
                        </div>
                        <div class="form-check form-check-inline with">
                            <input class="form-check-input" type="radio" name="Radio2" id="inlineRadioOptions1"
                                (change)="onBehaviurSelect($event)" value="last3months" [(ngModel)]="selectedValue">
                            <label class="form-check-label" for="inlineRadio2">Last 3Months</label>
                        </div>
                        <div class="form-check form-check-inline with">
                            <input class="form-check-input" type="radio" name="Radio2" id="inlineRadioOptions1"
                                value="last6months" (change)="onBehaviurSelect($event)" [(ngModel)]="selectedValue">
                            <label class="form-check-label" for="inlineRadio3">Last 6moths</label>
                        </div>
                    </div>
                    <div>
                        <div class="line1"></div>
                    </div>
                    <div>
                        <h5 class="text1">Search By Date Range</h5>
                    </div>

                    <div class="mb-3">
                      
                        <mat-form-field class="example-full-width" appearance="fill">
                            <mat-label> start date</mat-label>
                            <input matInput [min]="minFromDate" [max]="maxFromDate" [matDatepicker]="frompicker"  (dateInput)="handleDateChange('start', $event)" [formControl]="start">
                            <mat-datepicker-toggle matSuffix [for]="frompicker"></mat-datepicker-toggle>
                            <mat-datepicker #frompicker></mat-datepicker>
                        </mat-form-field>
                        
                    <span>To</span>
                        
                        <mat-form-field class="example-full-width" appearance="fill">
                            <mat-label>End date</mat-label>
                            <input matInput [min]="minToDate" [max]="maxToDate" [matDatepicker]="topicker"
                            (dateInput)="handleDateChange('end', $event)" [formControl]="end">
                            <mat-datepicker-toggle matSuffix [for]="topicker"></mat-datepicker-toggle>
                            <mat-datepicker #topicker></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-lg-12 text-center">
                    <button class="applybtn" (click)="apply()">Apply </button>
                </div>
            </div>
        </div>

    </div>